
@if (transportName()) {
  <span class="text__name ci-paragraph-p1-semibold">
    {{ transportName() | translate}}
  </span>
}